/**
 * Reads the payload of a JWT without verifying it. Enough for the one question
 * asked here — which promoter a token addresses — and never for authorization:
 * the API decides that on every request.
 */
export function readClaims(token) {
  try {
    const payload = String(token).split('.')[1];
    if (!payload) return {};

    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = decodeURIComponent(
      atob(base64)
        .split('')
        .map((char) => `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join(''),
    );

    const claims = JSON.parse(decoded);

    return claims && typeof claims === 'object' ? claims : {};
  } catch {
    return {};
  }
}

/** True when two tokens address different promoters — the tab has to reload. */
export function promoterChanged(previousToken, nextToken) {
  const previous = readClaims(previousToken).promoter_id;
  const next = readClaims(nextToken).promoter_id;

  if (previous === undefined || next === undefined) return false;

  return previous !== next;
}
